(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7442],{

/***/ 51469:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sx": function() { return /* binding */ useBreakpointValue; }
/* harmony export */ });
/* unused harmony exports Hide, Show, useBreakpoint, useColorModePreference, useMediaQuery, usePrefersReducedMotion, useQuery */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32067);
/* harmony import */ var _chakra_ui_react_env__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18229);
/* harmony import */ var _chakra_ui_breakpoint_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54302);
// ../../../react-shim.js


// src/media-query.tsx

var getBreakpoint = (theme, value) => {
  var _a;
  return ((_a = theme == null ? void 0 : theme.breakpoints) == null ? void 0 : _a[value]) ?? value;
};
function useQuery(props) {
  const { breakpoint = "", below, above } = props;
  const theme = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .useTheme */ .Fg)();
  const bpBelow = getBreakpoint(theme, below);
  const bpAbove = getBreakpoint(theme, above);
  let query = breakpoint;
  if (bpBelow) {
    query = `(max-width: ${bpBelow})`;
  } else if (bpAbove) {
    query = `(min-width: ${bpAbove})`;
  }
  return query;
}

// src/use-media-query.ts


function useMediaQuery(query, options = {}) {
  const { ssr = true, fallback } = options;
  const env = (0,_chakra_ui_react_env__WEBPACK_IMPORTED_MODULE_2__/* .useEnvironment */ .O)();
  const queries = Array.isArray(query) ? query : [query];
  let fallbackValues = Array.isArray(fallback) ? fallback : [fallback];
  fallbackValues = fallbackValues.filter((v) => v != null);
  const [value, setValue] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(() => {
    return queries.map((query2, index) => ({
      media: query2,
      matches: ssr ? !!fallbackValues[index] : env.window.matchMedia(query2).matches
    }));
  });
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    setValue(queries.map((query2) => ({
      media: query2,
      matches: env.window.matchMedia(query2).matches
    })));
    const mql = queries.map((query2) => env.window.matchMedia(query2));
    const handler = (evt) => {
      setValue((prev) => {
        return prev.slice().map((item) => {
          if (item.media === evt.media)
            return { ...item, matches: evt.matches };
          return item;
        });
      });
    };
    mql.forEach((mql2) => {
      if (typeof mql2.addListener === "function") {
        mql2.addListener(handler);
      } else {
        mql2.addEventListener("change", handler);
      }
    });
    return () => {
      mql.forEach((mql2) => {
        if (typeof mql2.removeListener === "function") {
          mql2.removeListener(handler);
        } else {
          mql2.removeEventListener("change", handler);
        }
      });
    };
  }, [env.window]);
  return value.map((item) => item.matches);
}

// src/media-query.hook.ts
function usePrefersReducedMotion(options) {
  const [prefersReducedMotion] = useMediaQuery("(prefers-reduced-motion: reduce)", options);
  return prefersReducedMotion;
}
function useColorModePreference(options) {
  const [isLight, isDark] = useMediaQuery(["(prefers-color-scheme: light)", "(prefers-color-scheme: dark)"], options);
  if (isLight)
    return "light";
  if (isDark)
    return "dark";
  return void 0;
}

// src/use-breakpoint.ts


// ../../utilities/shared-utils/src/index.ts
function isObject(value) {
  const type = typeof value;
  return value != null && (type === "object" || type === "function") && !Array.isArray(value);
}

// src/use-breakpoint.ts
function useBreakpoint(arg) {
  var _a;
  const opts = isObject(arg) ? arg : { fallback: arg ?? "base" };
  const theme = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .useTheme */ .Fg)();
  const breakpoints = theme.__breakpoints.details.map(({ minMaxQuery, breakpoint }) => ({
    breakpoint,
    query: minMaxQuery.replace("@media screen and ", "")
  }));
  const fallback = breakpoints.map((bp) => bp.breakpoint === opts.fallback);
  const values = useMediaQuery(breakpoints.map((bp) => bp.query), { fallback, ssr: opts.ssr });
  const index = values.findIndex((value) => value == true);
  return ((_a = breakpoints[index]) == null ? void 0 : _a.breakpoint) ?? opts.fallback;
}

// src/use-breakpoint-value.ts



// src/media-query.utils.ts

function getClosestValue(values, breakpoint, breakpoints = _chakra_ui_breakpoint_utils__WEBPACK_IMPORTED_MODULE_3__/* .breakpoints */ .AV) {
  let index = Object.keys(values).indexOf(breakpoint);
  if (index !== -1) {
    return values[breakpoint];
  }
  let stopIndex = breakpoints.indexOf(breakpoint);
  while (stopIndex >= 0) {
    const key = breakpoints[stopIndex];
    if (values.hasOwnProperty(key)) {
      index = stopIndex;
      break;
    }
    stopIndex -= 1;
  }
  if (index !== -1) {
    const key = breakpoints[index];
    return values[key];
  }
  return void 0;
}

// src/use-breakpoint-value.ts
function useBreakpointValue(values, arg) {
  var _a;
  const opts = isObject(arg) ? arg : { fallback: arg ?? "base" };
  const breakpoint = useBreakpoint(opts);
  const theme = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .useTheme */ .Fg)();
  if (!breakpoint)
    return;
  const breakpoints = Array.from(((_a = theme.__breakpoints) == null ? void 0 : _a.keys) || []);
  const obj = Array.isArray(values) ? Object.fromEntries(Object.entries((0,_chakra_ui_breakpoint_utils__WEBPACK_IMPORTED_MODULE_3__/* .arrayToObjectNotation */ .Yq)(values, breakpoints)).map(([key, value]) => [key, value])) : values;
  return getClosestValue(obj, breakpoint, breakpoints);
}

// src/visibility.tsx
function Visibility(props) {
  const { breakpoint, hide, children, ssr } = props;
  const [show] = useMediaQuery(breakpoint, { ssr });
  const isVisible = hide ? !show : show;
  const rendered = isVisible ? children : null;
  return rendered;
}

// src/show.tsx
function Show(props) {
  const { children, ssr } = props;
  const query = useQuery(props);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Visibility, {
    breakpoint: query,
    ssr
  }, children);
}
Show.displayName = "Show";

// src/hide.tsx
function Hide(props) {
  const { children, ssr } = props;
  const query = useQuery(props);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Visibility, {
    breakpoint: query,
    hide: true,
    ssr
  }, children);
}
Hide.displayName = "Hide";



/***/ }),

/***/ 63733:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// THIS FILE IS AUTO GENERATED
var GenIcon = (__webpack_require__(15787)/* .GenIcon */ .w_)
module.exports.d = function IoChevronBack (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"48","d":"M328 112L184 256l144 144"}}]})(props);
};


/***/ }),

/***/ 31237:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "TeaserList": function() { return /* reexport */ TeaserList; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(41799);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/button/dist/index.esm.js
var index_esm = __webpack_require__(47741);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/icon/dist/index.esm.js
var dist_index_esm = __webpack_require__(52494);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/media-query/dist/index.esm.js
var media_query_dist_index_esm = __webpack_require__(51469);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var layout_dist_index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(30719);
// EXTERNAL MODULE: ./src/config/entity-mapping.ts
var entity_mapping = __webpack_require__(51285);
;// CONCATENATED MODULE: ./src/components/Teaser/TeaserRenderer.tsx


var TeaserRenderer = function(param) {
    var teaser = param.teaser, teaserLayout = param.teaserLayout;
    var teaserName = "Teaser_".concat(teaserLayout);
    var Component = entity_mapping/* EntityMapping */.f[teaserName] || null;
    if (!Component) {
        console.warn("[TeaserRenderer] Teaser not found", teaserName);
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, {
        title: teaser.__typename === "NodeArticle" ? teaser.teaserTitle || teaser.headline : teaser.title,
        url: teaser.url,
        image: teaser.teaserImage,
        text: teaser.teaserText,
        layout: teaserLayout
    });
};

// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(30933);
// EXTERNAL MODULE: ./node_modules/swiper/modules/pagination/pagination.min.css
var pagination_min = __webpack_require__(68770);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/io5/IoChevronForward.js
var IoChevronForward = __webpack_require__(18935);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/io5/IoChevronBack.js
var IoChevronBack = __webpack_require__(63733);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 90 modules
var swiper_esm = __webpack_require__(71911);
// EXTERNAL MODULE: ./src/context/PageContext.ts
var PageContext = __webpack_require__(40353);
;// CONCATENATED MODULE: ./src/components/Paragraph/TeaserList/TeaserList.tsx








// CSS






var SliderButton = function(_param) {
    var buttonType = _param.buttonType, swiperRef = _param.swiperRef, props = (0,_object_without_properties/* default */.Z)(_param, [
        "buttonType",
        "swiperRef"
    ]);
    var onClick = function() {
        buttonType === "next" ? swiperRef === null || swiperRef === void 0 ? void 0 : swiperRef.slideNext() : swiperRef === null || swiperRef === void 0 ? void 0 : swiperRef.slidePrev();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Button */.zx, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        pos: "absolute",
        cursor: "pointer",
        onClick: onClick,
        top: "calc(50% - 25px)",
        transform: "translateY(-50%)",
        zIndex: 9,
        left: buttonType === "next" ? "auto" : {
            base: 0,
            md: "-60px"
        },
        right: buttonType === "prev" ? "auto" : {
            base: 0,
            md: "-60px"
        },
        color: "white",
        bg: "primary",
        fontSize: "4xl",
        borderRadius: "sm",
        h: "40px",
        w: "40px",
        _hover: {
            bg: "primaryDark"
        },
        _active: {
            bg: "primaryDarker"
        }
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Icon */.JO, {
            as: buttonType === "next" ? IoChevronForward/* IoChevronForward */.m : IoChevronBack/* IoChevronBack */.d
        })
    }));
};
var TeaserListSlider = function(param) {
    var data = param.data;
    var pageContext = (0,react.useContext)(PageContext/* PageContext */.z);
    var filteredTeasers = data.teasers.filter(function(teaser) {
        var ref;
        return teaser.id !== (pageContext === null || pageContext === void 0 ? void 0 : (ref = pageContext.entity) === null || ref === void 0 ? void 0 : ref.id);
    });
    var ref = (0,react.useState)(null), swiperRef = ref[0], setSwiperRef = ref[1];
    var ref1 = (0,react.useState)({
        isEnd: true,
        isStart: true
    }), swiperData = ref1[0], setSwiperData = ref1[1];
    var slidesPerView = (0,media_query_dist_index_esm/* useBreakpointValue */.Sx)({
        base: 1,
        md: data.teaserLayout === "image_title" ? 4 : 3
    }) || 1;
    if (slidesPerView > filteredTeasers.length) slidesPerView = filteredTeasers.length;
    var hasMoreSlides = filteredTeasers.length > slidesPerView;
    var updateSwiperData = function(swiper) {
        setSwiperData({
            isEnd: swiper.isEnd,
            isStart: swiper.isBeginning
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Box */.xu, {
        className: data.__typename,
        pos: "relative",
        __css: {
            ".swiper": {
                paddingBottom: "50px"
            },
            ".swiper-pagination-bullet-active": {
                bg: "primary"
            }
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                onSlideChange: function(swiper) {
                    updateSwiperData(swiper);
                },
                modules: [
                    swiper_esm/* Pagination */.tl
                ],
                pagination: {
                    clickable: true
                },
                onSwiper: function(swiper) {
                    setSwiperRef(swiper);
                    updateSwiperData(swiper);
                },
                spaceBetween: 20,
                slidesPerView: slidesPerView,
                children: filteredTeasers.map(function(teaser, i) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TeaserRenderer, {
                            teaser: teaser,
                            teaserLayout: data.teaserLayout
                        })
                    }, i);
                })
            }),
            hasMoreSlides && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderButton, {
                        buttonType: "next",
                        swiperRef: swiperRef,
                        disabled: swiperData.isEnd
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderButton, {
                        buttonType: "prev",
                        swiperRef: swiperRef,
                        disabled: swiperData.isStart
                    })
                ]
            })
        ]
    });
};
var TeaserList = function(param) {
    var data = param.data;
    var pageContext = (0,react.useContext)(PageContext/* PageContext */.z);
    if (data.teaserLayout !== "list") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(TeaserListSlider, {
            data: data
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* VStack */.gC, {
        spacing: 9,
        children: data.teasers.filter(function(teaser) {
            var ref;
            return teaser.id !== (pageContext === null || pageContext === void 0 ? void 0 : (ref = pageContext.entity) === null || ref === void 0 ? void 0 : ref.id);
        }).map(function(teaser, i) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Box */.xu, {
                width: "100%",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TeaserRenderer, {
                    teaser: teaser,
                    teaserLayout: data.teaserLayout
                })
            }, i);
        })
    });
};

;// CONCATENATED MODULE: ./src/components/Paragraph/TeaserList/index.ts



/***/ })

}]);